import { render, staticRenderFns } from "./detailFeedbackAutoClaim.vue?vue&type=template&id=1257c022&"
import script from "./detailFeedbackAutoClaim.vue?vue&type=script&lang=js&"
export * from "./detailFeedbackAutoClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports